import { EmailListItem } from "../../../Items/EmailListItem";
import { TimeZone } from "client/DateAndTime/timezones";
import { ReactElement, useMemo } from "react";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { generateTrackingId, isNil } from "client/Misc/utils";
import { useEmailNavigationHandler } from "../../../Navigation/useEmailNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";
import { convertAppColor } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { AppColorKind, AppColorViewModel } from "client/Api/Apps/common";

export type EmailItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Email>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	tabIndex: number;
};

export const EmailItemView = (props: EmailItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		emailId,
		parentFolderName,
		receivedDateTime,
		subject,
		ownerName,
		color: persistedColor
	} = item.email;

	const color = useMemo(
		(): AppColorViewModel => {
			if (isNil(persistedColor)) {
				return { kind: AppColorKind.Primary };
			}

			return convertAppColor(persistedColor);
		},
		[persistedColor]
	);


	const openHandler: () => void = useEmailNavigationHandler({
		emailId,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("email-item", `|${emailId}`)}
			onClick={openHandler}
		>
			<EmailListItem
				emailId={emailId}
				ownerName={ownerName}
				parentFolderName={parentFolderName}
				receivedDateTime={receivedDateTime}
				subject={subject}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
				color={color}
			/>
		</GlobalSearchItem>
	);
};
EmailItemView.displayName = "EmailItemView";